import { queryClient } from '@hotjar/webapp/utils/react-query';
import { useCurrentSite } from '@hotjar/site';
import type { UseQueryResult, UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';
import { getStartPageContent } from './api';
import type { StartPageContent } from './types';

const START_PAGE_CONTENT_QUERY_KEY = 'start_page_content';
const START_PAGE_CONTENT_STALE_TIME = 10000;

export const invalidateStartPageContentQuery = (): void => {
  queryClient.invalidateQueries([START_PAGE_CONTENT_QUERY_KEY]);
};

export const useStartPageContent = <TSelected = StartPageContent>(
  options?: Pick<UseQueryOptions<StartPageContent, Error, TSelected>, 'select'>,
): UseQueryResult<TSelected> => {
  const { data: currentSite } = useCurrentSite();
  const enabled = currentSite?.id !== undefined;

  return useQuery({
    queryKey: [START_PAGE_CONTENT_QUERY_KEY, { siteId: currentSite?.id }],
    queryFn: () => {
      if (!enabled) throw new Error();
      return getStartPageContent(currentSite?.id);
    },
    enabled,
    select: options?.select,
    staleTime: START_PAGE_CONTENT_STALE_TIME,
    refetchOnWindowFocus: false,
  });
};

export const useHotjarTips = (): UseQueryResult<StartPageContent['proTips']> => {
  const select = ({ proTips }: { proTips: StartPageContent['proTips'] }) => proTips;

  return useStartPageContent({ select });
};
